import { render, staticRenderFns } from "./GameDiscount.vue?vue&type=template&id=585510b2&scoped=true&"
import script from "./GameDiscount.vue?vue&type=script&lang=js&"
export * from "./GameDiscount.vue?vue&type=script&lang=js&"
import style0 from "./GameDiscount.vue?vue&type=style&index=0&id=585510b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585510b2",
  null
  
)

export default component.exports